export const countryActionType = {
  SAGA_GET_COUNTRY_LIST: 'SAGA_GET_COUNTRY_LIST',
}

export function sagaGetCountryCodesAction() {
  return {
    type: countryActionType.SAGA_GET_COUNTRY_LIST,
  }
}
